import { defineMessages } from "react-intl";

/** Section-level strings: page titles the views own, and the delete dialogs. */
export const sectionMessages = defineMessages({
  optionSetListTitle: {
    defaultMessage: "Option Sets", id: '3/eg0D',
    description: "compose option set list, page title",
  },
  optionSetCreateTitle: {
    defaultMessage: "Create option set", id: 'z4gGPB',
    description: "compose option set create, page title",
  },
  optionSetDeleteTitle: {
    defaultMessage: "Delete option set", id: 'LpkOXX',
    description: "compose option set detail, dialog title",
  },
  optionSetDeleteContent: {
    defaultMessage:
      "Delete {name}? Its {count, plural, one {# choice} other {# choices}} go with it, and the product stops asking the question.", id: 'wcosty',
    description: "compose option set detail, dialog content",
  },
  feeListTitle: {
    defaultMessage: "Fees", id: 'B4FAFL',
    description: "compose fee list, page title",
  },
  feeCreateTitle: {
    defaultMessage: "Create fee", id: '8nnGGj',
    description: "compose fee create, page title",
  },
  feeDeleteTitle: {
    defaultMessage: "Delete fee", id: 'vkwWAJ',
    description: "compose fee detail, dialog title",
  },
  feeDeleteContent: {
    defaultMessage:
      "Delete {name}? The charge stops being added to this product. Orders already placed keep it.", id: 'wDLfPa',
    description: "compose fee detail, dialog content",
  },
  complianceListTitle: {
    defaultMessage: "Compliance", id: 'P5/sDy',
    description: "compose compliance list, page title",
  },
  complianceTitle: {
    defaultMessage: "Compliance: {name}", id: 'l4Ty49',
    description: "compose compliance detail, page title",
  },
  complianceDeleteTitle: {
    defaultMessage: "Clear compliance", id: 'nEmz39',
    description: "compose compliance detail, dialog title",
  },
  complianceDeleteContent: {
    defaultMessage:
      "Clear the compliance record for {name}? Its warning and its shipping restrictions go with it.", id: 'YoPvrE',
    description: "compose compliance detail, dialog content",
  },
  product: {
    defaultMessage: "Product", id: '0/aTJM',
    description: "compose, the product a row hangs off",
  },
  productHelp: {
    defaultMessage: "The product this belongs to. It is set once and does not move.", id: '8R23s4',
    description: "compose, product picker help text",
  },
  products: {
    defaultMessage: "Products", id: 'jlna0l',
    description: "compose, the products a question is asked on",
  },
  productsHelp: {
    defaultMessage:
      "Every product that asks this question. One question can be asked on as many products as it fits.", id: 'rJOtAS',
    description: "compose, products picker help text",
  },
  searchPlaceholder: {
    defaultMessage: "Search by SKU or name", id: 'jpEto9',
    description: "compose list, search field",
  },
  railWhereItShows: {
    defaultMessage: "Where this shows", id: 'smn8ZK',
    description: "compose option set detail, right rail card title",
  },
  railWhereItCharges: {
    defaultMessage: "Where this charges", id: 'NvvmD1',
    description: "compose fee detail, right rail card title",
  },
  railWhatItCovers: {
    defaultMessage: "What this covers", id: 'Q02RUe',
    description: "compose compliance detail, right rail card title",
  },
  railProductUnset: {
    defaultMessage: "Not picked yet", id: 'aJ/qrm',
    description: "compose detail right rail, no product chosen on a create form",
  },
});

/** The option set list and the option set form. */
export const optionSetMessages = defineMessages({
  create: {
    defaultMessage: "Create option set", id: 'yvmTKp',
    description: "compose option set list, button",
  },
  feesTab: {
    defaultMessage: "Fees", id: '2ybDWU',
    description: "compose option set list, link to the fee list",
  },
  complianceTab: {
    defaultMessage: "Compliance", id: '84Kgso',
    description: "compose option set list, link to the compliance list",
  },
  colQuestion: {
    defaultMessage: "Question", id: 'xL+0fk',
    description: "compose option set list, column",
  },
  colProduct: {
    defaultMessage: "Product", id: 'DU5vpq',
    description: "compose option set list, column",
  },
  colPromptType: {
    defaultMessage: "Asked as", id: 'nEbky1',
    description: "compose option set list, column",
  },
  colRequired: {
    defaultMessage: "Required", id: '/tLgDK',
    description: "compose option set list, column",
  },
  // The list fragment carries no choice count: the contract has no such field,
  // and the position is what orders the questions on the product page.
  colPosition: {
    defaultMessage: "Position", id: 'Cj2hbL',
    description: "compose option set list, column",
  },
  noOptionSets: {
    defaultMessage: "No option sets yet", id: 'H2kxGV',
    description: "compose option set list, empty state",
  },
  noOptionSetMatches: {
    defaultMessage: "No option sets match that search.", id: '/LJNQI',
    description: "compose option set list, empty state while a search is on",
  },
  generalTitle: {
    defaultMessage: "The question", id: 'juO0Af',
    description: "compose option set detail, card title",
  },
  fieldName: {
    defaultMessage: "Internal name", id: 'rciYjv',
    description: "compose option set detail, field",
  },
  fieldNameHelp: {
    defaultMessage: "What staff call this question. Shoppers see it only if the label is empty.", id: 'Ds6f64',
    description: "compose option set detail, field help",
  },
  fieldLabel: {
    defaultMessage: "Shopper label", id: '8dLiB5',
    description: "compose option set detail, field",
  },
  fieldLabelHelp: {
    defaultMessage: "What the shopper is asked on the product page.", id: 'lOTMX0',
    description: "compose option set detail, field help",
  },
  fieldPromptType: {
    defaultMessage: "Asked as", id: 'gR6Fj0',
    description: "compose option set detail, field",
  },
  fieldNote: {
    defaultMessage: "Note", id: 'fTzb48',
    description: "compose option set detail, field",
  },
  fieldNoteHelp: {
    defaultMessage: "Shown under the question. Leave empty for none.", id: 'ii7bYz',
    description: "compose option set detail, field help",
  },
  fieldSortOrder: {
    defaultMessage: "Position", id: 'pT1FWZ',
    description: "compose option set detail, field",
  },
  fieldSortOrderHelp: {
    defaultMessage: "Where this question sits among the product's other questions.", id: 'nRfeLi',
    description: "compose option set detail, field help",
  },
  fieldSortOrderHelpDefault: {
    defaultMessage:
      "Where this question sits among the product's other questions. A new one starts at {position}, after the ones the product already asks.", id: '3fdfdk',
    description: "compose option set create, field help naming the default position",
  },
  fieldRequired: {
    defaultMessage: "Required", id: '2fEXvf',
    description: "compose option set detail, checkbox",
  },
  promptChoiceOne: {
    defaultMessage: "Pick one", id: '536lI+',
    description: "compose option set prompt type",
  },
  promptChoiceMany: {
    defaultMessage: "Pick any", id: 'G85mXU',
    description: "compose option set prompt type",
  },
  promptText: {
    defaultMessage: "Free text", id: 'yuXVdg',
    description: "compose option set prompt type",
  },
  promptDate: {
    defaultMessage: "Date", id: 'kMbVHj',
    description: "compose option set prompt type",
  },
  promptDatetime: {
    defaultMessage: "Date and time", id: '1h84/v',
    description: "compose option set prompt type",
  },
  promptImage: {
    defaultMessage: "Image upload", id: 'cEP2Nz',
    description: "compose option set prompt type",
  },
});

/** The choices grid inside the option set detail page. */
export const valueMessages = defineMessages({
  title: {
    defaultMessage: "Choices ({count})", id: 'oCi5K/',
    description: "compose option value grid, card title",
  },
  empty: {
    defaultMessage: "This question has no choices yet", id: 'R5YWVR',
    description: "compose option value grid, empty state",
  },
  addValue: {
    defaultMessage: "Add choice", id: 'M/KhtY',
    description: "compose option value grid, button",
  },
  removeRow: {
    defaultMessage: "Remove this choice", id: 'XDfQDx',
    description: "compose option value grid, row menu",
  },
  removeSelected: {
    defaultMessage: "Remove", id: 'm9jHOA',
    description: "compose option value grid, selection action",
  },
  colName: {
    defaultMessage: "Choice", id: 'cufh/X',
    description: "compose option value grid, column",
  },
  colSkuFragment: {
    defaultMessage: "SKU fragment", id: 'SFQD8P',
    description: "compose option value grid, column",
  },
  colPriceDelta: {
    defaultMessage: "Price change ({currency})", id: 'Z0mLtm',
    description: "compose option value grid, column",
  },
  colPriceDeltaNoCurrency: {
    defaultMessage: "Price change", id: 'V9KPhO',
    description: "compose option value grid, column with no channel currency",
  },
  colImageUrl: {
    defaultMessage: "Image URL", id: 'XDhkAh',
    description: "compose option value grid, column",
  },
  signedHelp: {
    defaultMessage:
      "Use a minus to take money off, for example -25. Leave a dealer cell empty and that group pays the same change as retail.", id: 'eEWGaz',
    description: "compose option value grid, footnote",
  },
  saveReplaces: {
    defaultMessage:
      "Saving replaces every choice with the rows in this grid. A row removed here is gone from the storefront once you save.",
    id: "+LA7WF",
    description: "compose option value grid, footnote about replace on save",
  },
  dealerColumnsHelp: {
    defaultMessage:
      "{count, plural, one {# dealer group} other {# dealer groups}} in this grid, more than fit here. Open it full screen, or use the column button to pick which ones show.", id: '6ee44r',
    description: "compose option value grid, footnote naming how many dealer columns there are",
  },
  fullScreen: {
    defaultMessage: "Full screen", id: 'THxDV/',
    description: "compose option value grid, button that gives the grid the whole window",
  },
  dealerColumnsHidden: {
    defaultMessage:
      "{count, plural, one {# column is hidden} other {# columns are hidden}}.", id: 'xq8vG0',
    description: "compose option value grid, footnote when the column picker hides columns",
  },
  noDealerGroups: {
    defaultMessage:
      "No dealer groups, so there are no dealer columns. Create one under Dealer Pricing and it appears here.", id: 'Mj9zjg',
    description: "compose option value grid, footnote when the store has no dealer groups",
  },
  unsaved: {
    defaultMessage: "{count, plural, one {# unsaved change} other {# unsaved changes}}", id: 'lU9l7p',
    description: "compose option value grid, header",
  },
});

/** The fee list and the fee form. */
export const feeMessages = defineMessages({
  create: {
    defaultMessage: "Create fee", id: 'cizCzE',
    description: "compose fee list, button",
  },
  optionSetsTab: {
    defaultMessage: "Option sets", id: 'j1qxZV',
    description: "compose fee list, link to the option set list",
  },
  colLabel: {
    defaultMessage: "Charge", id: '+8FhdR',
    description: "compose fee list, column",
  },
  colProduct: {
    defaultMessage: "Product", id: '4xprFc',
    description: "compose fee list, column",
  },
  colSku: {
    defaultMessage: "SKU", id: 'kySl3d',
    description: "compose fee list, column",
  },
  colAmount: {
    defaultMessage: "Amount", id: '2t+feT',
    description: "compose fee list, column",
  },
  colApplyTo: {
    defaultMessage: "Charged", id: 'rpXab3',
    description: "compose fee list, column",
  },
  colRequired: {
    defaultMessage: "Required", id: 'bP77oh',
    description: "compose fee list, column",
  },
  noFees: {
    defaultMessage: "No fees yet", id: 'r8GaPi',
    description: "compose fee list, empty state",
  },
  generalTitle: {
    defaultMessage: "The charge", id: 'a4N+oI',
    description: "compose fee detail, card title",
  },
  fieldLabel: {
    defaultMessage: "Label", id: 'hx40Ud',
    description: "compose fee detail, field",
  },
  fieldLabelHelp: {
    defaultMessage: "What the shopper sees this charge called at checkout.", id: 'tm+3Gh',
    description: "compose fee detail, field help",
  },
  fieldSku: {
    defaultMessage: "SKU", id: 'DV0ogV',
    description: "compose fee detail, field",
  },
  fieldSkuHelp: {
    defaultMessage: "The code this charge shows up as on the order and in your accounting.", id: 'N+LGSJ',
    description: "compose fee detail, field help",
  },
  fieldBasis: {
    defaultMessage: "Charged as", id: 'Eyb7Aw',
    description: "compose fee detail, field",
  },
  fieldAmount: {
    defaultMessage: "Amount", id: 'KtEIN9',
    description: "compose fee detail, field; the currency or percent sign is an adornment on it",
  },
  fieldApplyTo: {
    defaultMessage: "Charged", id: 'YY09Ol',
    description: "compose fee detail, field",
  },
  fieldRequired: {
    defaultMessage: "Charge this on every order for this product", id: 'ow4bCQ',
    description: "compose fee detail, checkbox",
  },
  fieldDeclineLabel: {
    defaultMessage: "Decline wording", id: 'yL+ezs',
    description: "compose fee detail, field",
  },
  fieldDeclineLabelHelp: {
    defaultMessage: "What the shopper clicks to skip this charge. Not shown when the charge is required.", id: 'W5hLXS',
    description: "compose fee detail, field help",
  },
  basisFixed: {
    defaultMessage: "Fixed amount", id: 'Aqw161',
    description: "compose fee basis",
  },
  basisPercent: {
    defaultMessage: "Percentage", id: 'YC6Si5',
    description: "compose fee basis",
  },
  scopePerUnit: {
    defaultMessage: "Per unit", id: 'nGny2P',
    description: "compose fee scope",
  },
  scopePerLine: {
    defaultMessage: "Once per line", id: 'BC0tAl',
    description: "compose fee scope",
  },
});

/** The compliance list and the compliance card. */
export const complianceMessages = defineMessages({
  setUp: {
    defaultMessage: "Add a product", id: '7XdtTd',
    description: "compose compliance list, button",
  },
  setUpTitle: {
    defaultMessage: "Set up product compliance", id: '+MFyq1',
    description: "compose compliance list, dialog title",
  },
  colProduct: {
    defaultMessage: "Product", id: 'XgvfuZ',
    description: "compose compliance list, column",
  },
  colProp65: {
    defaultMessage: "Prop 65", id: 'USue+F',
    description: "compose compliance list, column",
  },
  colRestrictedStates: {
    defaultMessage: "Will not ship to", id: '3RgMXc',
    description: "compose compliance list, column",
  },
  colZones: {
    defaultMessage: "Ships only to", id: 'ROj8CQ',
    description: "compose compliance list, column",
  },
  noCompliance: {
    defaultMessage: "No products carry a compliance record yet", id: 'Kkbvq4',
    description: "compose compliance list, empty state",
  },
  listSubtitle: {
    defaultMessage:
      "Every product that has a record. A product with none is not listed: open that product and use its Options, charges and compliance tab.",
    id: "c07z/6",
    description: "compose compliance list, what the list holds",
  },
  prop65Only: {
    defaultMessage: "Prop 65 only", id: 'zdEo3D',
    description: "compose compliance list, prop65 filter",
  },
  warningTitle: {
    defaultMessage: "Warnings", id: 'fcur5/',
    description: "compose compliance detail, card title",
  },
  restrictionTitle: {
    defaultMessage: "Where it ships", id: 'gpa+Iz',
    description: "compose compliance detail, card title",
  },
  fieldProp65: {
    defaultMessage: "This product carries a Proposition 65 warning", id: 'Sq1zGT',
    description: "compose compliance detail, checkbox",
  },
  fieldProp65Text: {
    defaultMessage: "Warning wording", id: 'CHy8YJ',
    description: "compose compliance detail, field",
  },
  fieldProp65TextHelp: {
    defaultMessage: "Leave empty for the storefront's standard short-form warning.", id: 'CRWAky',
    description: "compose compliance detail, field help",
  },
  fieldRestrictedStates: {
    defaultMessage: "States it will not ship to", id: 'eYeFOr',
    description: "compose compliance detail, field",
  },
  fieldRestrictedStatesHelp: {
    defaultMessage: "Two-letter codes, separated by commas. For example CA, NY, WA.", id: 'mQUgFl',
    description: "compose compliance detail, field help",
  },
  fieldZones: {
    defaultMessage: "Ships only to these zones", id: 'i+kWNU',
    description: "compose compliance detail, field",
  },
  fieldZonesHelp: {
    defaultMessage:
      "Naming any zone restricts this product to the countries they cover. Leave empty to ship everywhere the store does.", id: 'KNpqiG',
    description: "compose compliance detail, field help",
  },
  zoneCountries: {
    defaultMessage: "{name} covers {countries}.",
    id: "H94wmk",
    description: "compose compliance detail, the countries a chosen zone enforces",
  },
  zoneCountriesNone: {
    defaultMessage: "{name} covers no countries.",
    id: "LaIfZl",
    description: "compose compliance detail, a chosen zone that holds no country",
  },
  zoneCountriesHelp: {
    defaultMessage:
      "A zone limits by country, never by state. To keep this product out of particular states, list them in the states field above.",
    id: "hTFDet",
    description: "compose compliance detail, zone field footnote",
  },
  fieldRestrictionMessage: {
    defaultMessage: "What a blocked shopper is told", id: 'nlu/n7',
    description: "compose compliance detail, field",
  },
  fieldRestrictionMessageHelp: {
    defaultMessage: "Shown when the cart cannot ship to where they are.", id: 'hkj6i0',
    description: "compose compliance detail, field help",
  },
  none: {
    defaultMessage: "None", id: 'iL8VqQ',
    description: "compose compliance, an empty list cell",
  },
  noZoneLimit: {
    defaultMessage: "No limit", id: 'fJ9551',
    description: "compose compliance, a product with no shipping zone restriction",
  },
  yes: {
    defaultMessage: "Yes", id: 'oeNPHk',
    description: "compose, a true cell",
  },
  no: {
    defaultMessage: "No", id: '0+jSpk',
    description: "compose, a false cell",
  },
});

/** The Compose tab on the stock product detail page. */
export const productTabMessages = defineMessages({
  optionSetsTitle: {
    defaultMessage: "Questions ({count})", id: 'hoWytm',
    description: "compose product tab, option set card title",
  },
  feesTitle: {
    defaultMessage: "Charges ({count})", id: 'bqzzjy',
    description: "compose product tab, fee card title",
  },
  complianceTitle: {
    defaultMessage: "Compliance", id: 'sG2Vx8',
    description: "compose product tab, compliance card title",
  },
  colChoices: {
    defaultMessage: "Choices", id: 'xMJCn1',
    description: "compose product tab, column",
  },
  noCompliance: {
    defaultMessage: "No compliance record. This product carries no warning and refuses nowhere.", id: 'LKUhGA',
    description: "compose product tab, compliance empty state",
  },
  addCompliance: {
    defaultMessage: "Add compliance", id: 'exlVVZ',
    description: "compose product tab, button",
  },
  editCompliance: {
    defaultMessage: "Edit compliance", id: 'cnlwt1',
    description: "compose product tab, button",
  },
  loadFailed: {
    defaultMessage: "Could not load what this product asks and charges.", id: '8AAeRP',
    description: "compose product tab, query error",
  },
});
